import {ACCESS_RIGHTS} from 'src/hooks/access-rights';

export const getAvailableAccessRights = (accessRights: string[]) => accessRights
    .filter(right => Object.keys(ACCESS_RIGHTS).includes(right));
